import { render } from "./WTableDialog.vue?vue&type=template&id=015a6f40&ts=true"
import script from "./WTableDialog.vue?vue&type=script&lang=ts"
export * from "./WTableDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__